/* eslint-disable no-useless-catch */
import { ProductPriceUnit } from '../containers/ProductionManager/ProductManager/Product/components/Unit/commons';
import { serialize } from '../utils';
import { FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/proposal-items';

export const ProposalItemApi = {
  find: async (option: any) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findForSyncProduct: async (option: FindForSyncProductOption) => {
    let url = `${pathname}/find-for-sync-product`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProposalItemsForCreateWholesaleDigitalMenu: async (
    option: FindProposalItemsForCreateWholesaleDigitalMenuQuery
  ) => {
    let url = `${pathname}/find-for-create-wholesale-digital-menu`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProposalItemForWholesaleCart: async (
    option: FindProposalItemForWholesaleCartBody
  ) => {
    let url = `${pathname}/find-for-wholesale-cart`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithIsResetFlag: async (
    option: FindProposalItemsWithIsResetFlagQuery
  ) => {
    let url = `${pathname}/find-with-is-reset`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findWithIsResetFlagV2: async (
    option: FindProposalItemsWithIsResetFlagQuery
  ) => {
    let url = `${pathname}/find-with-is-reset-v2`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProposalItemOrProduct: async (
    orderID: string,
    body: FindProposalItemOrProductBody
  ) => {
    const url = `${pathname}/find-proposal-items-or-products-for-order/${orderID}`;

    try {
      const response = await entityService.post(url, body);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findFreeProposalItemsForDigitalMenu: async (
    digitalMenuCategoryID: string,
    option: any
  ) => {
    let url = `${pathname}/free-proposal-items-for-digital-menu-category/${digitalMenuCategoryID}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  getCount: async (option: any = {}) => {
    let url = `${pathname}/count`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createQuickly: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/quickly`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCustomerQuantity: async (
    id: string,
    body: UpdateProposalItemCustomerQuantityBody
  ) => {
    const url = `${pathname}/${id}/customer-quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateCustomerQuantityV2: async (
    id: string,
    body: UpdateProposalItemCustomerQuantityBody
  ) => {
    const url = `${pathname}/${id}/customer-quantity-v2`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateNote: async (id: string, body: any = {}) => {
    const url = `${pathname}/update-note/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePriceOrQuantity: async (
    id: string,
    body: UpdateProposalItemPriceOrQuantityBody
  ) => {
    const url = `${pathname}/${id}/price-or-quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  multiUpdatePriceOrQuantity: async (
    body: MultiUpdateProposalItemPriceOrQuantityBody
  ) => {
    const url = `${pathname}/multi/price-or-quantity`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindProposalItemForWholesaleCartBody {
  entityCategoryID?: string;
  customerProductName?: string;
  supplerName?: string;

  customerID?: string;
  page: number;
  take?: number;
  order?: any;
}

export interface FindProposalItemOrProductBody {
  itemIDs?: string[];
  name?: string;
  suggestLimit: number;
}

export interface FindProposalItemsForCreateWholesaleDigitalMenuQuery {
  customerID: string;
  supplierID?: string;
}

export interface UpdateProposalItemPriceOrQuantityBody {
  id: string;
  isPriceBlocked?: boolean;
  priceUnit?: ProductPriceUnit[];
  isAutoProposed?: boolean;
  reportType?: number;
  relativeQuantity?: number;
  absoluteQuantity?: number;
}

export interface MultiUpdateProposalItemPriceOrQuantityBody {
  proposalItems: UpdateProposalItemPriceOrQuantityBody[];
  customerID: string;
  supplierID: string;
  isReset?: boolean;
  excludedProposalItemIDs?: string[];
}

export interface FindProposalItemsWithIsResetFlagQuery extends FindOptions {
  isReset: boolean;
  supplierID: string;
  customerID: string;
  customerStatusIn: number[];
  customerStatusNotIn: number[];
  supplierProductName?: string;
  customerProductName?: string;
  entityCategoryID?: string;
}

export interface UpdateProposalItemCustomerQuantityBody {
  customerQuantity: number;
  shouldNotCheckQuantity?: boolean;
}

export interface FindForSyncProductOption extends FindOptions {
  partnerEntityID: string;
  partnerOwnerID: string;
  entityCategoryID: string;
  name?: string;
}
